// Fixed header with Headroom
import Headroom from 'headroom.js';
const header = document.querySelector('.header');

const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
const isDesktop = vw > 1024;

if (header) {
    const headroom = new Headroom(header, {
        offset: 0,
        tolerance: 5
    });
    headroom.init();
}

